import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import СalendarEvent from "~/views/calendarEvent"

const getInitialProps: GetInitialPropsType = async ({ req, query }) => {
  const apiContext = await getApiContext(
    [
      { url: "/calendar/element", code: query.slug as string },
      { url: "/formwithcontacts/list", code: "calendar" },
    ],
    req ? req.headers.host : location.host,
  )

  const { name } = apiContext["/calendar/element"].response
  const crumbs = generateCrumbs(req?.url, name)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
СalendarEvent.getInitialProps = getInitialProps

export default СalendarEvent
